import VueGtag from 'vue-gtag'
import { createApp } from 'vue'

const app = createApp({})
app.use(VueGtag, {
  config: { id: import.meta.env.VUE_GOOGLE_ANALYTICS },
})

app.mount('#app')
